import { Box } from '@chakra-ui/react';

type RangePropovderProps = {
    color: 'red' | 'yellow' | 'green' | string;
};

const ScoreBadge = (props: RangePropovderProps) => {
    

    const getColor = (color: string) => {
        switch (color) {
            case 'green':
                return '#66c61c';
            case 'yellow':
                return '#eaaa08';
            case 'red':
            default:
                return '#d92d20';
        }
    }

    return (
        <Box 
            backgroundColor={getColor(props.color)}
            borderRadius="100%"
            height="20px"
            width="20px"
            margin="5px auto"
        />
    );
};

export default ScoreBadge;